const DEFAULT_USER_ACTION_WINDOW = 18;
const DAYS_PER_MONTH = 30;

export const getUserActionWindowExpirationDate = (
  creationDate: string,
  actionWindowTime: string | number = DEFAULT_USER_ACTION_WINDOW
): Date => {
  const expirationDate = new Date(Date.parse(creationDate));

  expirationDate.setHours(0, 0, 0, 0);
  expirationDate.setDate(
    expirationDate.getDate() +
      Number.parseInt(String(actionWindowTime), 10) * DAYS_PER_MONTH
  );

  return expirationDate;
};
